import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser, getUserByUid } from "../services/authService";
import ThemeLogo from "./ThemeLogo";

export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await loginUser(form.email, form.password);
      console.log('User logged in:', user);
      
      // Get user details from Firestore
      const userData = await getUserByUid(user.uid);
      console.log('User data from Firestore:', userData);
      
      // Comment out previous functionality and redirect to admin dashboard
      // if (userData) {
      //   // Check if user has accepted terms
      //   if (userData.termsAccepted === true) {
      //     console.log('User has accepted terms, navigating to subscription');
      //     navigate('/subscription');
      //   } else {
      //     console.log('User has not accepted terms, navigating to terms page');
      //     navigate('/terms-and-conditions');
      //   }
      // } else {
      //   console.log('No user data found in Firestore, navigating to terms page');
      //   navigate('/terms-and-conditions');
      // }
      
      // Redirect to admin dashboard
      console.log('User logged in successfully, navigating to admin dashboard');
      navigate('/admin');
    } catch (err) {
      let userMessage = 'Login failed. Please try again.';
      if (err.code === 'auth/invalid-credential' || err.code === 'auth/wrong-password' || err.code === 'auth/user-not-found') {
        userMessage = 'Invalid email or password. Please try again.';
      } else if (err.code === 'auth/too-many-requests') {
        userMessage = 'Too many failed attempts. Please try again later.';
      }
      setError(userMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      width: '100vw',
      background: 'rgba(0,0,0,0.0)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 2000 
    }}>
      <div style={{
        background: '#fff',
        borderRadius: '32px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        padding: '48px 40px 32px 40px',
        maxWidth: 400,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
      }}>
        <span
          onClick={() => navigate('/')}
          style={{
            position: 'absolute',
            top: 18,
            right: 24,
            fontSize: 22,
            color: '#888',
            cursor: 'pointer',
            zIndex: 10,
            fontWeight: 400,
            lineHeight: 1,
            transition: 'color 0.2s',
          }}
          aria-label="Close login"
          title="Close"
        >
          &times;
        </span>
        <ThemeLogo style={{ width: 130, height: 130, marginBottom: 24 }} alt="Logo" />
        <h2 style={{ fontSize: '2.1rem', fontWeight: 700, margin: 0, color: '#111', alignSelf: 'flex-start' }}>Login</h2>
        <div style={{ width: '100%', margin: '8px 0 24px 0', alignSelf: 'flex-start' }}>
          <span style={{ color: '#222', fontSize: '1.08rem', fontWeight: 500 }}>Don't have an account? </span>
          <span style={{ color: '#8b5cf6', fontWeight: 600, cursor: 'pointer', transition: 'color 0.2s' }} 
                onMouseEnter={(e) => e.target.style.color = '#6366f1'} 
                onMouseLeave={(e) => e.target.style.color = '#8b5cf6'} 
                onClick={() => navigate('/register')}>Register Now</span>
        </div>
        {error && (
          <div style={{ color: 'red', marginBottom: 12, textAlign: 'center', fontWeight: 600 }}>{error}</div>
        )}
        <form style={{ width: '100%' }} onSubmit={handleSubmit}>
          <input
            type="text"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Enter email or user name"
            style={{
              width: '100%',
              padding: '16px',
              borderRadius: '10px',
              border: 'none',
              background: '#f3f3ff',
              color: '#222',
              fontSize: '1.08rem',
              marginBottom: 18,
              outline: 'none',
              fontWeight: 500,
              boxSizing: 'border-box',
            }}
            required
          />
          <div style={{ position: 'relative', width: '100%' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Password"
              style={{
                width: '100%',
                padding: '16px',
                borderRadius: '10px',
                border: 'none',
                background: '#f3f3ff',
                color: '#222',
                fontSize: '1.08rem',
                marginBottom: 18,
                outline: 'none',
                fontWeight: 500,
                boxSizing: 'border-box',
              }}
              required
            />
            <span
              onClick={() => setShowPassword(v => !v)}
              style={{
                position: 'absolute',
                right: 18,
                top: 18,
                cursor: 'pointer',
                color: '#b0b0c3',
                fontSize: 20,
                userSelect: 'none',
              }}
              aria-label="Toggle password visibility"
            >
              {showPassword ? (
                <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 4.5c-4.5 0-7.5 4.5-7.5 4.5s3 4.5 7.5 4.5 7.5-4.5 7.5-4.5-3-4.5-7.5-4.5zm0 7.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" fill="#b0b0c3"/></svg>
              ) : (
                <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 10S4.5 5.5 10 5.5s8.5 4.5 8.5 4.5-3 4.5-8.5 4.5S1.5 10 1.5 10zm8.5 2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" fill="#b0b0c3"/></svg>
              )}
            </span>
          </div>
          <button
            type="submit"
            style={{
              width: '100%',
              background: 'linear-gradient(135deg, #6d28d9 0%, #4f46e5 45%, #22d3ee 100%)',
              color: '#fff',
              fontWeight: 700,
              fontSize: '1.18rem',
              border: 'none',
              borderRadius: '12px',
              padding: '16px 0',
              margin: '10px 0 0 0',
              boxShadow: '0 4px 16px rgba(139, 92, 246, 0.25)',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
          >
            Login
          </button>
        </form>
        <div style={{ width: '100%', textAlign: 'center', marginTop: 28, color: '#888', fontSize: '1.05rem', fontWeight: 500 }}>
          <span
            style={{ cursor: 'pointer', color: '#22d3ee', textDecoration: 'underline', transition: 'color 0.2s' }}
            onMouseEnter={(e) => e.target.style.color = '#67e8f9'} 
            onMouseLeave={(e) => e.target.style.color = '#22d3ee'}
            onClick={() => navigate('/forgot-password')}
          >
            Forgot password?
          </span>
        </div>
      </div>
    </div>
  );
} 